import { Component, Input } from '@angular/core';

import { PlatformLegalEntityAddressDto } from '@well/platform-administration/company/domain';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { constants } from '@well/infra/constants';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';

@Component({
    selector: 'well-platform-legal-entity-address-inputs',
    imports: [FloatLabel, FormsModule, TranslateModule, InputTextModule, FormInlineErrorDirective],
    templateUrl: './platform-legal-entity-address-inputs.component.html',
    styleUrls: ['./platform-legal-entity-address-inputs.component.scss'],
    viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformLegalEntityAddressInputsComponent {

  @Input() platformLegalEntityAddressDto: PlatformLegalEntityAddressDto = new PlatformLegalEntityAddressDto();

}
